
import { FastingProtocol } from '@/types/fasting';

export const fastingProtocols: FastingProtocol[] = [
  {
    id: '16-8',
    name: '16:8 Intermittent Fasting',
    description: 'Fast for 16 hours, eat during an 8-hour window',
    durationHours: 16,
    milestones: [
      {
        hour: 2,
        title: 'Digestion Continues',
        description: 'Your body is still digesting your last meal and maintaining normal blood glucose levels.'
      },
      {
        hour: 6,
        title: 'Entering Fasting State',
        description: 'Blood sugar begins to drop and your body starts to shift away from glucose for energy.'
      },
      {
        hour: 10,
        title: 'Fat Burning Begins',
        description: 'Your body is now shifting to fat stores for energy, increasing fat metabolism.'
      },
      {
        hour: 14,
        title: 'Autophagy Activation',
        description: 'Cellular cleanup processes are beginning, removing damaged cell components.'
      },
      {
        hour: 16,
        title: 'Fast Complete',
        description: "You've completed your fast! Your body has experienced numerous metabolic benefits."
      }
    ]
  },
  {
    id: '18-6',
    name: '18:6 Intermittent Fasting',
    description: 'Fast for 18 hours, eat during a 6-hour window',
    durationHours: 18,
    milestones: [
      {
        hour: 2,
        title: 'Digestion Continues',
        description: 'Your body is still digesting your last meal and maintaining normal blood glucose levels.'
      },
      {
        hour: 6,
        title: 'Entering Fasting State',
        description: 'Blood sugar begins to drop and your body starts to shift away from glucose for energy.'
      },
      {
        hour: 10,
        title: 'Fat Burning Begins',
        description: 'Your body is now shifting to fat stores for energy, increasing fat metabolism.'
      },
      {
        hour: 14,
        title: 'Autophagy Activation',
        description: 'Cellular cleanup processes are beginning, removing damaged cell components.'
      },
      {
        hour: 16,
        title: 'Deep Autophagy',
        description: 'Enhanced cellular cleanup and regeneration processes are now in effect.'
      },
      {
        hour: 18,
        title: 'Fast Complete',
        description: "You've completed your fast! Your body has experienced deeper metabolic benefits."
      }
    ]
  },
  {
    id: '20-4',
    name: '20:4 Warrior Diet',
    description: 'Fast for 20 hours, eat during a 4-hour window',
    durationHours: 20,
    milestones: [
      {
        hour: 2,
        title: 'Digestion Continues',
        description: 'Your body is still digesting your last meal and maintaining normal blood glucose levels.'
      },
      {
        hour: 6,
        title: 'Entering Fasting State',
        description: 'Blood sugar begins to drop and your body starts to shift away from glucose for energy.'
      },
      {
        hour: 10,
        title: 'Fat Burning Begins',
        description: 'Your body is now shifting to fat stores for energy, increasing fat metabolism.'
      },
      {
        hour: 14,
        title: 'Autophagy Activation',
        description: 'Cellular cleanup processes are beginning, removing damaged cell components.'
      },
      {
        hour: 16,
        title: 'Deep Autophagy',
        description: 'Enhanced cellular cleanup and regeneration processes are now in effect.'
      },
      {
        hour: 18,
        title: 'Growth Hormone Increase',
        description: 'Human growth hormone levels rise, supporting muscle maintenance and repair.'
      },
      {
        hour: 20,
        title: 'Fast Complete',
        description: "You've completed your fast! Your body has experienced significant metabolic benefits."
      }
    ]
  },
  {
    id: '24',
    name: '24-Hour Fast',
    description: 'A full day fast from dinner to dinner',
    durationHours: 24,
    milestones: [
      {
        hour: 2,
        title: 'Digestion Continues',
        description: 'Your body is still digesting your last meal and maintaining normal blood glucose levels.'
      },
      {
        hour: 6,
        title: 'Entering Fasting State',
        description: 'Blood sugar begins to drop and your body starts to shift away from glucose for energy.'
      },
      {
        hour: 10,
        title: 'Fat Burning Begins',
        description: 'Your body is now shifting to fat stores for energy, increasing fat metabolism.'
      },
      {
        hour: 14,
        title: 'Autophagy Activation',
        description: 'Cellular cleanup processes are beginning, removing damaged cell components.'
      },
      {
        hour: 16,
        title: 'Deep Autophagy',
        description: 'Enhanced cellular cleanup and regeneration processes are now in effect.'
      },
      {
        hour: 18,
        title: 'Growth Hormone Increase',
        description: 'Human growth hormone levels rise, supporting muscle maintenance and repair.'
      },
      {
        hour: 22,
        title: 'Insulin Sensitivity Improving',
        description: 'Your insulin sensitivity is increasing, helping to regulate blood sugar more effectively.'
      },
      {
        hour: 24,
        title: 'Fast Complete',
        description: 'Congratulations on completing a 24-hour fast! Your body has undergone significant metabolic benefits.'
      }
    ]
  },
  {
    id: '3-day',
    name: '3-Day Extended Fast',
    description: 'A 72-hour fast for deeper cellular benefits',
    durationHours: 72,
    milestones: [
      {
        hour: 4,
        title: 'Digestion Complete',
        description: 'Your body has finished processing your last meal and begins entering the fasted state.'
      },
      {
        hour: 12,
        title: 'Glycogen Depleted',
        description: 'Your liver has used up its glycogen stores. Fat burning increases significantly.'
      },
      {
        hour: 18,
        title: 'Ketosis Beginning',
        description: 'Your body starts producing ketones, an alternative fuel source derived from fat.'
      },
      {
        hour: 24,
        title: 'Deep Ketosis',
        description: 'Ketone production increases, providing energy and mental clarity.'
      },
      {
        hour: 36,
        title: 'Autophagy Peak',
        description: 'Cellular recycling processes reach peak levels, removing damaged components.'
      },
      {
        hour: 48,
        title: 'Growth Hormone Surge',
        description: 'Growth hormone levels increase up to 5x, promoting tissue repair and regeneration.'
      },
      {
        hour: 54,
        title: 'Immune System Reset',
        description: 'Your body begins recycling old immune cells and generating new ones.'
      },
      {
        hour: 60,
        title: 'Stem Cell Production',
        description: 'Stem cell production increases, supporting the regeneration of multiple cell types.'
      },
      {
        hour: 72,
        title: 'Fast Complete',
        description: 'Congratulations on completing a 3-day fast! Your body has experienced profound metabolic benefits.'
      }
    ]
  },
  {
    id: '7-day',
    name: '7-Day Extended Fast',
    description: 'A week-long fast for maximum autophagy and immune regeneration',
    durationHours: 168,
    milestones: [
      {
        hour: 4,
        title: 'Digestion Complete',
        description: 'Your body has finished processing your last meal and begins entering the fasted state.'
      },
      {
        hour: 12,
        title: 'Glycogen Depleted',
        description: 'Your liver has used up its glycogen stores. Fat burning increases significantly.'
      },
      {
        hour: 18,
        title: 'Ketosis Beginning',
        description: 'Your body starts producing ketones, an alternative fuel source derived from fat.'
      },
      {
        hour: 24,
        title: 'Deep Ketosis',
        description: 'Ketone production increases, providing energy and mental clarity.'
      },
      {
        hour: 36,
        title: 'Autophagy Peak',
        description: 'Cellular recycling processes reach peak levels, removing damaged components.'
      },
      {
        hour: 48,
        title: 'Growth Hormone Surge',
        description: 'Growth hormone levels increase up to 5x, promoting tissue repair and regeneration.'
      },
      {
        hour: 72,
        title: 'Immune System Reset',
        description: 'Your body begins recycling old immune cells and generating new ones.'
      },
      {
        hour: 96,
        title: 'Deep Cellular Cleansing',
        description: 'Extended autophagy leads to significant cellular cleansing and tissue repair.'
      },
      {
        hour: 120,
        title: 'Complete Immune Regeneration',
        description: 'The immune system has undergone significant renewal and regeneration.'
      },
      {
        hour: 144,
        title: 'Insulin Sensitivity Maximized',
        description: 'Your cells are now highly responsive to insulin, optimizing blood glucose regulation.'
      },
      {
        hour: 168,
        title: 'Fast Complete',
        description: 'Congratulations on this remarkable achievement! Your body has undergone a complete metabolic reset.'
      }
    ]
  }
];
